var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_c('i-switch',{attrs:{"value":_vm.value,"loading":_vm.loading,"trueValue":_vm.trueValue,"beforeChange":_vm.beforeChange,"falseValue":_vm.falseValue},on:{"on-change":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }